import { Languages, Check } from 'lucide-react'
import { DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent, DropdownMenuItem } from '@racefront/shadcn-ui'
import { useIntl } from 'react-intl'
import { useLocalization } from '../context/localization-context'
import { SuppotedLocales } from '../i18n/types'

const localeNames: Partial<Record<SuppotedLocales, string>> = {
  [SuppotedLocales.EN_GB]: 'English',
  [SuppotedLocales.SV_SE]: 'Svenska',
  [SuppotedLocales.EL_GR]: 'Ελληνικά',
}

interface LocaleSwitcherProps {
  locales?: SuppotedLocales[]
  className?: string
}

export function LocaleSwitcher({ locales, className }: LocaleSwitcherProps) {
  const intl = useIntl()
  const { locale: currentLocale, setLocale } = useLocalization()

  const availableLocales: SuppotedLocales[] = locales || [
    SuppotedLocales.EN_GB,
    SuppotedLocales.SV_SE,
    SuppotedLocales.EL_GR,
  ]

  const handleLocaleChange = (locale: SuppotedLocales) => {
    setLocale(locale)
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className={className}>
        <Languages />
        {intl.formatMessage({ id: 'Header.Language', defaultMessage: 'Language' })}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {availableLocales.map((locale) => (
          <DropdownMenuItem key={locale} onClick={() => handleLocaleChange(locale)}>
            <span>{localeNames[locale]}</span>
            {currentLocale === locale && <Check className="ml-auto h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
